import React, { useState } from "react";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Form, Input, Button, Divider, message, Card } from 'antd';
import { Link, useLocation } from "react-router-dom";

import conditional from "../../utils/conditional";
import { useSession } from "../../utils/Session";
import { apiCall } from "../../utils/Api";

export default function AccountForgot(props) {


    const { activate = false } = props;

    const loc = useLocation();
    const [, setSession] = useSession();

    let hasToken = false;
    if (loc.search) {
        if (loc.search.includes("?token=")) {
            hasToken = loc.search.replace("?token=", "");
        }
    }

    const [token] = useState(hasToken);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [registered, setRegistered] = useState(false);
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [email, setEmail] = useState("");


    const title = (activate) ? "Verify Your Account" : "Forgotten Password"
    const callback = (activate) ? "account/activate" : "account/forgot";

    // Email 
    const onSendForgotPasswordEmail = (_status, _result) => {
        setLoading(false);
        if (!_status) {
            setError(true);
            if (_result.error === "No account for that email") {
                setErrorMessage(_result.error);
            } else {
                setErrorMessage("There was an error. Please ensure you've entered a valid email address.");
            }

        } else {
            if (_result.success) {
                setEmailSent(true);
            }
        }
    }

    const sendForgotPasswordEmail = (v) => {
        if (loading) { return; }
        setLoading(true);
        setRegistered(false);
        setError(false);
        let { email_address } = v;
        setEmail(email_address);
        apiCall("account/emailPasswordToken", { "email_address": email_address, "callback_url": callback }, onSendForgotPasswordEmail);
    }

    // Update 
    const onUpdatePassword = (_status, _result) => {
        if (_status) {
            message.success('Your password has been successfully changed.', 3);
            setSession(_result);
        } else {
            setError(true);
            setErrorMessage(_result.error);
        }
    }

    const updatePassword = (_values) => {
        apiCall("account/resetPassword", { password: _values.password, token: token }, onUpdatePassword);
    }

    const passwordResetForm = () => {
        return (
            <div className="shim" style={{ "minHeight": "120px", "marginTop": "calc(20vh)" }}>
                <Card headStyle={{ "borderBottom": (!props.dark) ? "1px solid #e6e6e6" : "1px solid #333333" }} hoverable style={{ "width": "310px", "margin": "0 auto", "border": "1px solid #e6e6e6", "cursor": "default" }}>
                    <div>

                        <div><span className="c">Password Change Utility</span></div>
                        <Divider style={{ "margin": "15px 0px" }} dashed />
                        <p>You may now enter a new password, minimum 8 characters:</p>
                        <Form onFinish={(values) => updatePassword(values)} layout="vertical">
                            <Form.Item
                                name="password"
                                label="New Password"
                                rules={[{
                                    required: true,
                                    min: 8,
                                    message: 'Password must be at least 8 characters.',
                                },]}
                                hasFeedback
                            >
                                <Input.Password placeholder="Password..." />
                            </Form.Item>
                            <Form.Item
                                name="confirm"
                                label="Confirm password"
                                dependencies={['password']}
                                hasFeedback
                                rules={[{
                                    required: true,
                                    message: 'Please confirm your password.',
                                }, ({ getFieldValue }) => ({
                                    validator(rule, value) {

                                        if (value.length < 8) {
                                            return Promise.reject('Password must be at least 8 characters.');
                                        }

                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject('The two passwords that you entered do not match.');
                                    },
                                }),]}
                            >
                                <Input.Password placeholder="Confirm Password..." min={8} max={12} />
                            </Form.Item>
                            {(error && <p style={{ "paddingTop": "15px", "color": "#ff4d4f", "textAlign": "center" }} className="error"><ExclamationCircleFilled /> {errorMessage}</p>)}
                            <Button type="primary" htmlType="submit">Change Password</Button>
                        </Form>
                    </div>
                </Card>
            </div>
        )
    }

    const displayEmailSentMessage = () => {
        return (
            <>
                <div className="shim" style={{ "minHeight": "120px", "marginTop": "calc(20vh)" }}>
                    <Card headStyle={{ "borderBottom": (!props.dark) ? "1px solid #e6e6e6" : "1px solid #333333" }} hoverable style={{ "width": "310px", "margin": "0 auto", "border": "1px solid #e6e6e6", "cursor": "default" }}>
                        <div><span className="c">Email sent!</span></div>
                        <Divider style={{ "margin": "15px 0px" }} dashed />
                        <p>An email has been sent to {email}. It will contain instructions on how to {(activate) ? "set" : "reset"} your password. Please check your email now.</p>
                        <p>Note: Check your spam folder in case your email system does not recognize our email address.</p>
                    </Card>
                </div>
            </>
        )
    }

    const display = () => {
        return (
            <div></div>
        )
    }

    const displayStatus = () => {
        if (token) {
            return passwordResetForm();
        }
        if (emailSent) {
            return displayEmailSentMessage();
        }
        return display();
    }

    return displayStatus();

}